<template>
  <div class="has-gradient-background" v-if="$mq.resize && $mq.above('500px')">
    <div class="container">
      <section class="section flex">
        <!-- <p class="is-white subtitle no-margin-bottom is-6">{{routeName}}</p> -->
        <p class="is-white subtitle no-margin-bottom is-6 m-l-auto">Home <icon scale="0.8" name="chevron-right"></icon> {{routeName}} <span v-if="subRoute"><icon scale="0.8" name="chevron-right"></icon> {{subRoute}}</span>  </p>
      </section>
    </div>
  </div>  
</template>

<script>
export default {
  props: {
    routeName: {
      type: String,
      required: true,
    },
    subRoute: {
      type: String,
      required: false, 
    }
  }
}
</script>

<style lang="scss" scoped>
.has-gradient-background {
  height: 35px;
}
.section {
  padding: 0rem 1.5rem;
  height: 35px;
}
svg {
  position: relative;
  top: 2px;
}
.flex {
  align-items: center;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// breadcrumb.vue?09b07b0f